import { InputText } from 'primereact/inputtext';
import React, { useEffect, useRef, useState } from 'react';
import 'react-phone-number-input/style.css'
import { useTranslation } from 'react-i18next';
import { useNavigate, useSearchParams } from 'react-router-dom';
import eventBus from '../common/EventBus';
import SearchService from '../service/SearchService';
import CustomSearchItemDetail from './CustomSearchItemDetail';
import CustomArtLabel from './CustomArtLabel';
import Constants from '../constants/Constants';
import CustomExhibitions from './CustomExhibitions';
import FileService from '../service/FileService';
import { Button } from 'primereact/button';

const CustomSearchDetail = (props) => {
    const { t } = useTranslation();
    const navigate = useNavigate();


    const [displayLoadingDialog, setDisplayLoadingDialog] = useState(false);

    const [search, setSearch] = useState('');
    const [searchResponse, setSearchResponse] = useState('');
    const [debouncedTerm, setDebouncedTerm] = useState('');
    const [searchInfo, setSearchInfo] = useState('');

    const [dataList, setDataList] = useState([]);
    const [filteredDataList, setFilteredDataList] = useState([]);
    const [filterTypeList, setFilterTypeList] = useState(["artist", "artwork", "exhibition", "company"]);
    const [filterType, setFilterType] = useState("");



    let [searchParams, setSearchParams] = useSearchParams();
    const [searchText, setSearchText] = useState(searchParams.get("searchText"));
    const [companyCode, setCompanyCode] = useState(searchParams.get("companyCode"));
    const [searchType, setSearchType] = useState(searchParams.get("searchType"));

    useEffect(() => {
        console.log("useEffect searchParams", searchParams, searchText, searchParams.get("searchText"))
        if (companyCode?.length > 0 || searchText?.length > 0) {
            onSearch();
        }
        else if (props?.onLoad === true) {
            onSearch();

        }

    }, [searchParams]);

    /**
     * Function to handle the key down event of the search input.
     * If the key is Enter, it will call the onSearch function.
     * @param {event} e - The key down event.
     */
    const onKeyDown = (e) => {
        //   console.log("onKeyDown", search + e.key);

        if (e.key === 'Enter') {
            onSearch(true);
        }//else if(e.key.length)


    }

    // Debounce işlemi
    useEffect(() => {
        const timerId = setTimeout(() => {
            setDebouncedTerm(search);
        }, 500); // 500ms bekleme süresi

        return () => {
            clearTimeout(timerId);
        };
    }, [search]);

    // Debounced terim değiştiğinde arama işlemini gerçekleştir
    useEffect(() => {
        if (debouncedTerm.length >= 3) {
            // Arama işleminizi burada gerçekleştirin
            onSearch(true);

            console.log('Arama yapılıyor:', debouncedTerm);
        }
    }, [debouncedTerm]);

    const onSearch = (param) => {
        let _searchTextParam = searchParams.get("searchText");
        let _companyCodeParam = searchParams.get("companyCode");
        let _searchTypeParam = searchParams.get("searchType");

        if (_searchTextParam)
            setSearchText(_searchTextParam);
        if (_companyCodeParam)
            setCompanyCode(_companyCodeParam);
        if (_searchTypeParam)
            setSearchType(_searchTypeParam);


        console.log("onSearch", search, param, searchText);
        setDisplayLoadingDialog(true);
        setSearchResponse([]);
        setDataList([]);
        setFilteredDataList([]);
        setSearchInfo("");


        let _companyCode = _companyCodeParam ? _companyCodeParam : "";
        let _search = search?.length > 0 ? search : _searchTextParam?.length > 0 ? _searchTextParam : "";
        let _searchType = _searchTypeParam ? _searchTypeParam : "";
        if (param) {
            _companyCode = "";
            _searchType = ""
        }
        console.log(" SearchService.search", _search, _companyCode, _searchType);

        SearchService.search(_search, _companyCode, _searchType).then(
            (response) => {

                console.log("search", response)
                if (response?.data?.data?.dataList?.length > 0) {
                    console.log("set search", response?.data?.data?.dataList)
                    setSearchResponse(response?.data?.data?.dataList[0]);
                    let _response = response?.data?.data?.dataList[0];

                    let _dataList = [];



                    _response?.artistList?.forEach(element => {
                        let _data = {
                            id: element.id,
                            profileImage: element.profileImage,
                            ownerName: element.ownerName,
                            name: element.name,
                            descr: element.descr,
                            filePath: element.filePath,
                            fileUpload: element.fileUpload,
                            type: "artist",
                            orderName: element.ownerName,
                            favoriteId: element.favoriteId
                        }
                        _dataList.push(_data);
                    });
                    _response?.artworkList?.forEach(element => {
                        let _data = {
                            id: element.id,
                            profileImage: element.profileImage,
                            ownerName: element.ownerName,
                            name: element.name,
                            descr: element.descr,
                            filePath: element.filePath,
                            fileUpload: element.fileUpload,
                            type: "artwork",
                            orderName: element.name,
                            favoriteId: element.favoriteId,
                            artYear: element.artYear,
                            artType: element.artType,
                            artWidth: element.artWidth,
                            artHeight: element.artHeight,
                            measureUnit: element.measureUnit,
                            material: element.material

                        }
                        _dataList.push(_data);
                    });

                    _response?.companyList?.forEach(element => {
                        let _data = {
                            id: element.id,
                            profileImage: element.profileImage,
                            ownerName: element.ownerName,
                            name: element.companyName,
                            descr: element.companyType,
                            filePath: element.filePath,
                            fileUpload: element.fileUpload,
                            type: "company",
                            orderName: element.companyName,
                            favoriteId: element.favoriteId
                        }
                        _dataList.push(_data);
                    });

                    _response?.exhibitList?.forEach(element => {
                        let _data = {
                            id: element.id,
                            profileImage: element.profileImage,
                            ownerName: element.ownerName,
                            name: element.name,
                            descr: element.descr,
                            filePath: element.filePath,
                            fileUpload: element.fileUpload,
                            type: "exhibition",
                            orderName: element.name,
                            favoriteId: element.favoriteId
                        }
                        _dataList.push(_data);
                    });
                    console.log("****************_dataList", _dataList)
                    _dataList = _dataList.sort((a, b) => a.orderName.localeCompare(b.orderName))
                    setDataList(_dataList);
                    setFilteredDataList(_dataList);

                    if (_response?.artistList?.length == 0 && _response?.artworkList?.length == 0 && _response?.companyList?.length == 0 && _response?.exhibitList?.length == 0) {
                        console.log("****************set search not found")

                        setSearchInfo(t("global_text_no_found"));



                    }
                }


                setDisplayLoadingDialog(false);
            },
            (error) => {
                console.log("inquireCharVal error*", error)

                setDisplayLoadingDialog(false);

                const _content =
                    (error.response &&
                        error.response.data &&
                        error.response.data.message) ||
                    error.message ||
                    error.toString();

                console.log(_content);

                if (error?.response?.status === 403 || error?.Error?.includes("403")) {

                    console.log("inquireCharVal logout******")
                    eventBus.dispatch("logout", props);
                } else {
                    props.toast.current.show({ severity: 'error', summary: t("global_error") + error?.response?.status, detail: t("global_error_detail"), life: 5000 });
                }
            }
        );
    }


    const onFilterDataList = (param) => {
        if (filterType === param) {
            param = "";
        }
        setFilterType(param);
        let _dataList = [];
        if (param && param != "") {
            _dataList = dataList.filter(item => item.type === param);
        } else {
            _dataList = dataList;
        }

        setFilteredDataList(_dataList);

    }



    return (
        <div style={{

        }}>
            <div className="'grid  flex-row">


                <div style={{ marginBottom: '2rem' }}>
                    <span className="block text-6xl  mb-1  p-2">
                        {t('search_result', { searchText: searchText })}
                    </span>
                    <div style={{
                        flexDirection: 'row',
                        display: 'flex',
                        //   justifyContent: 'space-between',
                        //padding: 10,
                    }}
                    >
                        <span className="block text-2xl  mb-1  p-2">
                            {t('exhibit_filter_header')}
                        </span>

                        {
                            filterTypeList.map((item, index) => (
                                <Button className={item === filterType ? "p-button-rounded mr-2 mb-2 p-2" : "p-button-rounded p-button-gray mr-2 mb-2"} label={t("favorites_filter_type_" + item)} onClick={() => onFilterDataList(item)} />

                            ))
                        }





                    </div>
                </div>




                <div className='grid flex flex-column pl-5 pr-5'               >
                    {
                        searchInfo &&
                        <div className='text-2xl  font-500-regular pt-2 pb-3 '>
                            {searchInfo}
                        </div>
                    }
                    {/*renderArtists()}
                    {renderCompanies()}

                    {renderArtWorks()}
                    {renderExhibits()*/}

                    <CustomSearchItemDetail data={filteredDataList} {...props} searchType={searchType} search={search}></CustomSearchItemDetail>


                </div>


            </div>

        </div>
    )
}

export default CustomSearchDetail;